<template>
  <div>
    <section class=" pa-3 light pa-md-10">
      <h3 class="my-5"> {{ $t('parts.selectCateg') }}
      </h3>
      <v-row justify="stretch">
        <v-col cols="12" lg="3" md="4"
               v-for="c in allModelCategories" :key="c.id"
        >
          <router-link
              class="white--text "
              :to="{name : 'CategParts', params:{categ_id: c.id, model_id: $route.params.model_id, categ_name: c.name}, query: {mark: $route.query.mark, model: $route.query.model, year: $route.query.year, category: c.name}}"
          >
            <v-card
                class="mx-auto fill-height"
                max-width="344"
            >
              <v-img :src="c.img_url"  max-height="150"
              />
              <v-card-text class="primary white--text text-center pa-1 mb-0 ">
                <strong>{{ c.name }}</strong>
              </v-card-text>
              <v-card-text v-if="c.subsShown">
                <v-list>
                  <v-list-item v-for="sub in c.sous_categories" v-bind:key="sub.id">
                    <v-list-item-content>
                      <v-list-item-title>
                        <router-link :to="{name : 'CategParts', params:{categ_id: 1, model_id: 1}}">
                          {{ sub.name }}
                        </router-link>
                      </v-list-item-title>
                      <v-list-item-subtitle> {{ sub.sous_related_categories.length }} Parts</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </router-link>
        </v-col>
      </v-row>
    </section>
    <v-dialog
      v-model="dialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <mail-box/>
  </div>

</template>
<script>
import MailBox from "../../components/MailBox.vue";
import {mapGetters} from 'vuex'

export default {
    name: 'Home',
    components: {MailBox},
    data: () => ({
        year: new Date().getFullYear(), 
        make: '',
        dialog: false
    }),
    methods: {
        fetchModels() {
        if (this.year && this.make)
            this.$store.dispatch('fetchMakeModels', {year: this.year, make_id: this.make})
        }
    },
    computed: {
        ...mapGetters(["allModelCategories"]),
    },
    created() {
        this.$store.dispatch("fetchMakes")
        this.dialog = true
        setTimeout(() => (this.dialog = false), 4000)
    }
}
</script>
<style scoped>
.border-r {
  border-right: 5px solid #0088ff;
}

.hero {
  height: 90vh;
  background: linear-gradient(rgba(0, 0, 0, 0.61), rgba(0, 0, 0, 0.61)), url('../../assets/img/3.jpg') center center no-repeat;
  background-size: contain;
}

</style>
